// extracted by mini-css-extract-plugin
export var banner = "_ed-0";
export var closeButton = "_ed-2";
export var greenCheckmark = "_ed-3";
export var hereLink = "_ed-4";
export var titleIcon = "_ed-1";